import React from 'react'
import { navigate } from '@reach/router'
import {
  Typography,
  Drawer,
  Toolbar,
  Grid,
  IconButton,
  Divider,
} from '@material-ui/core'
import { Link } from 'gatsby-theme-material-ui'
import { useContextProvider, closeMenu } from '../store/context'
import MenuOpenIcon from '@material-ui/icons/MenuOpen'
const Navigation = ({ navigation = [] }) => {
  const [isOpen, dispatch] = useContextProvider()
  const goTo = e => location => {
    navigate(location)
    dispatch(closeMenu())
  }

  return (
    <Drawer open={isOpen} onClick={() => dispatch(closeMenu())}>
      <Toolbar variant="dense" disableGutters>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
        >
          <IconButton onClick={() => dispatch(closeMenu())} color="primary">
            <MenuOpenIcon />
          </IconButton>
        </Grid>
      </Toolbar>
      <Divider />
      <ul
        style={{
          listStyle: `none`,
          margin: `0 30px 0 auto`,
          padding: `1.45rem 1.0875rem`,
          lineHeight: `0.5`,
        }}
      >
        {navigation.map(page => (
          <li key={page.slug} className={`li-link`}>
            <Typography>
              <Link
                style={{ color: 'blue' }}
                onClick={e => goTo(e)('/')}
                className={`link`}
              >
                {page.title}
              </Link>
            </Typography>

            {page.pages && (
              <ul
                style={{
                  padding: `0 15px`,
                  listStyle: `none`,
                }}
              >
                {page.pages.map(page => (
                  <li key={page.slug} className={`li-link`}>
                    <Typography>
                      <Link
                        style={{ color: 'blue' }}
                        onClick={e => goTo(e)(page.slug)}
                        className={`link`}
                      >
                        {page.title}
                      </Link>
                    </Typography>

                    {page.pages && (
                      <ul
                        style={{
                          padding: `0 15px`,
                          listStyle: `none`,
                        }}
                      >
                        {page.pages.map(page => (
                          <li key={page.slug} className={`li-link`}>
                            <Typography>
                              <Link
                                style={{ color: 'blue' }}
                                onClick={e => goTo(e)(page.slug)}
                                className={`link`}
                              >
                                {page.title}
                              </Link>
                            </Typography>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </Drawer>
  )
}

export default Navigation
